module.exports = __webpack_public_path__ + "static/img/zxkf.44fa0495.png";